// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2wSlM","productName":"Table_productName__1-nOW"};